import {
  Button,
  Card,
  Col,
  Container,
  Image,
  Row,
} from "@themesberg/react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import NotFoundImage from "../../assets/img/illustrations/404.svg";
import React from "react";
import { Routes } from "../../routes";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default () => {
  let history = useHistory();

  // useEffect(() => {
    // let timer;
    // const resetTimer = () => {
    //   if (timer) clearTimeout(timer);
    //   timer = setTimeout(() => {
    //     // Redirect to login page
    //     history.push('/login');

    //     // Clear session storage
    //     sessionStorage.clear();
    //   }, 400);
    // };
    // return () => {
    //   if (timer) clearTimeout(timer);
    // }
    // setTimeout(() => {
    //   history.push("/sign-in");
    //   sessionStorage.clear();
    //   console.log("clear");
    // }, 500);
    // setTimeout(() => {
      // history.push("/sign-in");
      // sessionStorage.clear();
      // console.log("clear");
    // }, 400);
    // return () => clearTimeout(timer);
    // eslint-disable-next-line
  // }, [])

  return (
    <main>
      <section className="vh-100 d-flex align-items-center justify-content-center">
        <Container>
          <Row>
            <Col
              xs={12}
              className="text-center d-flex align-items-center justify-content-center"
            >
              <div>
                <Card.Link as={Link} to={Routes.DashboardOverview.path}>
                  <Image src={NotFoundImage} className="img-fluid w-75" />
                </Card.Link>
                <h3 className="text-primary mt-5">
                Oops!You dont have any <span className="fw-bolder">Access</span> <br/>
                Please contact your <span className="fw-bolder">Admin</span>
                </h3>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
